import React, { useState } from 'react';

const LicenseAgreement = () => {
  const [language, setLanguage] = useState('thai');
  const changeLanguage = (lang) => setLanguage(lang);

  const content = {
    thai: (
      <div className="content active">
        <h2>ข้อกำหนดและเงื่อนไขการให้บริการ</h2>
        <h3>1. บทนำ</h3>
        <p>ข้อกำหนดและเงื่อนไขนี้เป็นข้อตกลงระหว่างผู้ให้บริการ The Adventures Online TH (ต่อไปนี้เรียกว่า "ผู้ให้บริการ") และผู้เล่น (ต่อไปนี้เรียกว่า "ผู้ใช้บริการ" หรือ "ผู้เล่น") ซึ่งการเข้าสู่ระบบและใช้บริการของเกมนี้ถือว่าผู้เล่นได้ยอมรับข้อตกลงทั้งหมดตามที่ระบุไว้</p>
        
        <h3>2. การสมัครและการใช้งาน</h3>
        <p>2.1 ผู้เล่นต้องมีอายุ 18 ปีขึ้นไป หรือได้รับความยินยอมจากผู้ปกครอง</p>
        <p>2.2 ผู้เล่นต้องให้ข้อมูลที่เป็นจริงและถูกต้องในการลงทะเบียนบัญชี</p>
        <p>2.3 บัญชีของผู้เล่นเป็นสิทธิส่วนบุคคล ห้ามโอน ยกให้ หรือขายต่อ เว้นแต่ได้รับความยินยอมจากผู้ให้บริการ</p>
        <p>2.4 ผู้ให้บริการมีสิทธิระงับบัญชีที่ละเมิดเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>
        
        <h3>3. สิทธิและหน้าที่ของผู้เล่น</h3>
        <p>3.1 ผู้เล่นมีสิทธิ์เข้าถึงและใช้บริการตามข้อกำหนดนี้</p>
        <p>3.2 ผู้เล่นต้องปฏิบัติตามกฎกติกาของเกมและหลีกเลี่ยงการกระทำที่ผิดกฎหมาย</p>
        <p>3.3 ผู้เล่นต้องไม่ใช้ซอฟต์แวร์ช่วยเล่น บอท หรือวิธีการที่ละเมิดความเป็นธรรมของเกม</p>
        <p>3.4 ผู้เล่นต้องไม่แอบอ้างเป็นผู้ดูแลระบบหรือแอดมินของเกม</p>
        <p>3.5 ผู้เล่นต้องไม่เผยแพร่หรือแชร์ข้อมูลที่เป็นอันตรายต่อเกม เช่น ไวรัส โค้ดไม่พึงประสงค์ หรือการแฮ็ก</p>
        
        <h3>4. สิทธิและหน้าที่ของผู้ให้บริการ</h3>
        <p>4.1 ผู้ให้บริการมีหน้าที่ดูแลรักษาระบบให้สามารถเล่นได้อย่างต่อเนื่อง</p>
        <p>4.2 ผู้ให้บริการมีสิทธิ์ในการระงับ แก้ไข หรือเปลี่ยนแปลงข้อมูลในเกมตามความเหมาะสม</p>
        <p>4.3 ผู้ให้บริการสามารถอัปเดต เปลี่ยนแปลงเงื่อนไขหรือระบบเกมโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>
        <p>4.4 ผู้ให้บริการไม่มีหน้าที่รับผิดชอบต่อความเสียหายของผู้เล่นที่เกิดจากการใช้เกมผิดวัตถุประสงค์</p>
        
        <h3>5. ข้อห้ามและบทลงโทษ</h3>
        <p>5.1 การใช้โปรแกรมช่วยเล่น (Bot, Macro, Hack, Cheat) โทษ: แบนบัญชีถาวร</p>
        <p>5.2 การใช้ภาษาหรือพฤติกรรมไม่เหมาะสม เช่น การด่าทอ การเหยียดเชื้อชาติ หรือการล่วงละเมิดทางเพศ โทษ: ระงับบัญชี 7 วัน หรือแบนถาวร</p>
        <p>5.3 การใช้บั๊กในเกมเพื่อแสวงหาผลประโยชน์ส่วนตัว โทษ: ระงับบัญชี 14 วัน และริบไอเทมที่ได้จากบั๊ก</p>
        <p>5.4 การโจมตีระบบเกมหรือพยายามเข้าถึงข้อมูลที่ไม่ได้รับอนุญาต โทษ: แบนบัญชีถาวรและอาจดำเนินคดีทางกฎหมาย</p>
        
        <h3>6. การคืนเงินและความรับผิดชอบ</h3>
        <p>6.1 สินค้าและบริการภายในเกมเป็นแบบ "ไม่มีการคืนเงิน" เว้นแต่จะมีข้อผิดพลาดจากระบบเกม</p>
        <p>6.2 ผู้ให้บริการไม่รับผิดชอบต่อการถูกแฮ็กบัญชีหรือข้อมูลสูญหายที่เกิดจากความประมาทของผู้เล่น</p>
        
        <h3>7. การเปลี่ยนแปลงข้อตกลง</h3>
        <p>7.1 ผู้ให้บริการขอสงวนสิทธิ์ในการเปลี่ยนแปลงข้อกำหนดโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</p>
        
        <h3>8. ข้อกฎหมายและการระงับข้อพิพาท</h3>
        <p>8.1 ข้อกำหนดและเงื่อนไขนี้อยู่ภายใต้กฎหมายไทย</p>
        <p>8.2 หากมีข้อพิพาท จะใช้กระบวนการทางกฎหมายตามศาลไทย</p>
        
        <h3>9. ติดต่อผู้ให้บริการ</h3>
        <p>เฟซบุ๊ก: facebook.com/TheAdventuresOnlineTH</p>
        <p>เว็บไซต์: https://www.ranworld-adventures.com/</p>
        
        <p><strong>ขอขอบคุณที่ร่วมเป็นส่วนหนึ่งของ The Adventures Online TH!</strong></p>
      </div>
    ),
    english: (
      <div className="content active">
        <h2>Terms of Service</h2>
        <h3>1. Introduction</h3>
        <p>These terms and conditions constitute an agreement between the service provider, The Adventures Online TH (hereinafter referred to as "Service Provider"), and the player (hereinafter referred to as "User" or "Player"). By logging into and using this game service, the player agrees to all the terms specified herein.</p>
        
        <h3>2. Registration and Usage</h3>
        <p>2.1 Players must be at least 18 years old or have parental consent.</p>
        <p>2.2 Players must provide true and accurate information when registering an account.</p>
        <p>2.3 Player accounts are personal and non-transferable. Selling or giving away accounts is prohibited unless authorized by the Service Provider.</p>
        <p>2.4 The Service Provider reserves the right to suspend accounts that violate the terms without prior notice.</p>
        
        <h3>3. Player Rights and Responsibilities</h3>
        <p>3.1 Players have the right to access and use the service under these terms.</p>
        <p>3.2 Players must comply with the game rules and avoid illegal or unethical behavior.</p>
        <p>3.3 Players must not use cheating software, bots, or other unfair gameplay methods.</p>
        <p>3.4 Players must not impersonate administrators or game moderators.</p>
        <p>3.5 Players must not share or distribute harmful content such as viruses, malicious code, or hacking tools.</p>
        
        <h3>4. Service Provider Rights and Responsibilities</h3>
        <p>4.1 The Service Provider is responsible for maintaining the game system for continuous playability.</p>
        <p>4.2 The Service Provider has the right to suspend, modify, or change game data as deemed necessary.</p>
        <p>4.3 The Service Provider can update or change terms and game mechanics without prior notice.</p>
        <p>4.4 The Service Provider is not liable for damages resulting from the misuse of the game.</p>
        
        <h3>5. Prohibited Actions and Penalties</h3>
        <p>5.1 Using bots, macros, hacks, or cheats – Penalty: Permanent account ban.</p>
        <p>5.2 Using offensive language, racism, or sexual harassment – Penalty: First offense: 7-day suspension. Second offense: Permanent account ban.</p>
        <p>5.3 Exploiting game bugs for personal gain – Penalty: 14-day suspension and revocation of unfairly gained items.</p>
        <p>5.4 Attacking game systems or attempting unauthorized access – Penalty: Permanent account ban and potential legal action.</p>
        
        <h3>6. Refunds and Liability</h3>
        <p>6.1 In-game purchases are "non-refundable" unless due to system errors.</p>
        <p>6.2 The Service Provider is not responsible for hacked accounts or data loss due to player negligence.</p>
        
        <h3>7. Amendments</h3>
        <p>7.1 The Service Provider reserves the right to modify the terms without prior notice.</p>
        
        <h3>8. Legal and Dispute Resolution</h3>
        <p>8.1 These terms are governed by the laws of Thailand.</p>
        <p>8.2 In case of disputes, both parties agree to attempt mediation before taking legal action under the jurisdiction of Thai courts.</p>
        
        <h3>9. Contact Information</h3>
        <p>Facebook: facebook.com/TheAdventuresOnlineTH</p>
        <p>Website: https://www.ranworld-adventures.com/</p>
        
        <p><strong>Thank you for being part of The Adventures Online TH!</strong></p>
      </div>
    ),
    chinese: (
      <div className="content active">
        <h2>服務條款</h2>
        <h3>1. 簡介</h3>
        <p>本服務條款是服務提供者 The Adventures Online TH（以下簡稱“服務提供者”）與玩家（以下簡稱“用戶”或“玩家”）之間的協議。通過登錄和使用此遊戲服務，玩家即表示同意本條款中規定的所有內容。</p>
        
        <h3>2. 註冊與使用</h3>
        <p>2.1 玩家必須年滿18歲，或獲得父母或監護人的同意。</p>
        <p>2.2 玩家在註冊帳戶時必須提供真實和準確的信息。</p>
        <p>2.3 玩家帳戶為個人專屬，不可轉讓、出售或贈與他人，除非獲得服務提供者的授權。</p>
        <p>2.4 服務提供者有權在未事先通知的情況下暫停違規帳戶。</p>
        
        <h3>3. 玩家權利與義務</h3>
        <p>3.1 玩家有權根據本條款使用遊戲服務。</p>
        <p>3.2 玩家必須遵守遊戲規則，避免非法或不道德行為。</p>
        <p>3.3 玩家不得使用外掛、機器人或其他不公平遊戲方式。</p>
        <p>3.4 玩家不得冒充管理員或遊戲監管人員。</p>
        <p>3.5 玩家不得分享或傳播病毒、惡意代碼或黑客工具。</p>
        
        <h3>4. 服務提供者權利與義務</h3>
        <p>4.1 服務提供者負責維護遊戲系統，以確保其穩定運行。</p>
        <p>4.2 服務提供者有權暫停、修改或更改遊戲數據。</p>
        <p>4.3 服務提供者可以隨時更改條款或遊戲機制，無需事先通知。</p>
        <p>4.4 服務提供者不對因遊戲錯誤使用而導致的損害負責。</p>
        
        <h3>5. 禁止行為與處罰</h3>
        <p>5.1 使用機器人、外掛或作弊 – 處罰：永久封鎖帳戶。</p>
        <p>5.2 使用攻擊性語言、種族歧視或性騷擾 – 處罰：首次違規暫停7天，再次違規永久封鎖帳戶。</p>
        <p>5.3 利用遊戲漏洞謀取私利 – 處罰：暫停帳戶14天，並收回不當獲得的物品。</p>
        <p>5.4 攻擊遊戲系統或試圖未經授權訪問 – 處罰：永久封鎖帳戶，並可能面臨法律責任。</p>
        
        <h3>6. 退款與責任</h3>
        <p>6.1 遊戲內購買均為“不可退款”，除非系統發生錯誤。</p>
        <p>6.2 服務提供者不對因玩家疏忽導致的帳戶被盜或數據丟失負責。</p>
        
        <h3>7. 條款變更</h3>
        <p>7.1 服務提供者保留修改條款的權利，無需事先通知。</p>
        
        <h3>8. 法律與爭議解決</h3>
        <p>8.1 本條款受泰國法律管轄。</p>
        <p>8.2 若發生爭議，雙方同意先進行調解，如無法解決，則依據泰國法院的法律程序處理。</p>
        
        <h3>9. 聯絡方式</h3>
        <p>Facebook: facebook.com/TheAdventuresOnlineTH</p>
        <p>網站: https://www.ranworld-adventures.com/</p>
        
        <p><strong>感謝您成為 The Adventures Online TH 的一部分！</strong></p>
      </div>
    )
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
      <div className="language-selector" style={{ marginBottom: '20px' }}>
        <button onClick={() => changeLanguage('thai')} style={{ marginRight: '10px', padding: '8px 16px', borderRadius: '5px', border: '1px solid #007bff', backgroundColor: '#007bff', color: '#fff', fontFamily: "Prompt" }}>ไทย</button>
        <button onClick={() => changeLanguage('english')} style={{ marginRight: '10px', padding: '8px 16px', borderRadius: '5px', border: '1px solid #007bff', backgroundColor: '#007bff', color: '#fff', fontFamily: "Prompt" }}>English</button>
        <button onClick={() => changeLanguage('chinese')} style={{ padding: '8px 16px', borderRadius: '5px', border: '1px solid #007bff', backgroundColor: '#007bff', color: '#fff', fontFamily: "Prompt" }}>中文</button>
      </div>
      <div style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
        {content[language]}
      </div>
    </div>
  );
};

export default LicenseAgreement;